import React from 'react';

const InputSimulation = () => {
  return (
    <section className="bg-white py-12">
      <div className="container-max px-6 sm:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 text-center mb-12">
            Así de fácil puedes crear una actividad con Tareia
          </h2>
          
          <div className="grid lg:grid-cols-2 gap-12 sm:gap-16 items-center">
            {/* Formulario Visual (NO funcional) */}
            <div className="bg-white rounded-3xl shadow-2xl p-6 sm:p-8 border-2 border-gray-100 pointer-events-none">
              <div className="space-y-5">
                {/* Campo Nivel */}
                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-3">
                    Nivel
                  </label>
                  <div className="relative">
                    <div className="w-full px-4 py-4 border-2 border-gray-300 rounded-xl bg-gray-50 text-gray-500 font-medium">
                      Primaria
                    </div>
                    <div className="absolute inset-y-0 right-0 flex items-center px-3 pointer-events-none">
                      <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </div>
                  </div>
                </div>

                {/* Campo Materia */}
                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-3">
                    Materia
                  </label>
                  <div className="relative">
                    <div className="w-full px-4 py-4 border-2 border-gray-300 rounded-xl bg-gray-50 text-gray-500 font-medium">
                      Matemáticas
                    </div>
                    <div className="absolute inset-y-0 right-0 flex items-center px-3 pointer-events-none">
                      <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </div>
                  </div>
                </div>
                
                {/* Campo Tema */}
                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-3">
                    Tema
                  </label>
                  <div className="relative">
                    <div className="w-full px-4 py-4 border-2 border-gray-300 rounded-xl bg-gray-50 text-gray-500 font-medium">
                      Fracciones básicas
                    </div>
                  </div>
                </div>
                
                {/* Campo Intención */}
                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-3">
                    Intención
                  </label>
                  <div className="relative">
                    <div className="w-full px-4 py-4 border-2 border-gray-300 rounded-xl bg-gray-50 text-gray-500 font-medium">
                      Reforzar
                    </div>
                    <div className="absolute inset-y-0 right-0 flex items-center px-3 pointer-events-none">
                      <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </div>
                  </div>
                </div>
                
                {/* Campo Contexto */}
                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-2">
                    Contexto de tu grupo (opcional)
                  </label>
                  <p className="text-xs text-gray-500 mb-3">
                    Ayuda a personalizar la actividad según nivel, dificultades o necesidades especiales
                  </p>
                  <div className="relative">
                    <div className="w-full px-4 py-4 border-2 border-gray-300 rounded-xl bg-gray-50 text-gray-500 font-medium min-h-[80px] flex items-start">
                      Grupo con distintos ritmos de aprendizaje
                    </div>
                  </div>
                </div>
                
                {/* Botón NO clicable */}
                <div className="w-full bg-gradient-to-r from-primary-600 to-secondary-600 text-white font-bold py-4 sm:py-5 px-6 rounded-xl shadow-xl text-base sm:text-lg text-center">
                  ✨ Generar actividad
                </div>
              </div>
            </div>
            
            {/* Transición y Resultado */}
            <div className="text-center">
              {/* Transición */}
              <div className="mb-12">
                <div className="flex items-center justify-center mb-6">
                  <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center animate-pulse">
                    <svg className="w-8 h-8 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                  </div>
                </div>
                <p className="text-lg sm:text-xl font-bold text-gray-700 mb-2">
                  En segundos obtienes esto
                </p>
                <p className="text-xs sm:text-sm text-gray-600">
                  Material didáctico listo para imprimir
                </p>
              </div>
              
              {/* Segunda Actividad - Detecta el Error */}
              <div className="relative max-w-sm sm:max-w-md mx-auto">
                {/* Badge */}
                <div className="absolute -top-4 -right-4 bg-orange-500 text-white px-4 py-2 rounded-full text-sm font-bold shadow-xl z-10">
                  📋 Material listo
                </div>
                
                {/* PDF Material Real */}
                <div className="bg-white rounded-3xl shadow-2xl p-4 sm:p-6 border-2 border-gray-100 transform -rotate-2 hover:rotate-0 transition-all duration-500">
                  <div className="space-y-4">
                    {/* Encabezado */}
                    <div className="border-b-2 border-orange-200 pb-3 bg-gradient-to-r from-orange-50 to-yellow-50 rounded-xl p-3 -m-1">
                      <p className="text-xs text-gray-900 mb-1 font-bold">📄 MATERIAL DIDÁCTICO GENERADO</p>
                      <h3 className="text-lg font-bold text-orange-600 mb-1">🔍 Detecta el error</h3>
                      <div className="flex gap-2 text-xs flex-wrap">
                        <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full font-medium">📚 Primaria</span>
                        <span className="bg-orange-100 text-orange-800 px-2 py-1 rounded-full font-medium">📊 Matemáticas</span>
                        <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full font-medium">⏱️ 15 min</span>
                      </div>
                    </div>
                    
                    {/* Instrucciones para el docente */}
                    <div className="bg-blue-50 rounded-lg p-3 border border-blue-200">
                      <h4 className="font-bold text-blue-900 text-xs mb-1">👨‍🏫 GUÍA PARA EL DOCENTE:</h4>
                      <p className="text-blue-800 text-xs">Entregue las hojas a los alumnos. Deben identificar el error en cada situación y escribir la respuesta correcta. Fomente la discusión sobre por qué está mal y cómo corregirlo.</p>
                    </div>
                    
                    {/* Material del alumno - Hoja entregable */}
                    <div className="space-y-3">
                      <p className="text-xs text-gray-600 font-medium">Lee cada situación y encuentra el error.</p>
                      
                      <div className="space-y-2">
                        <div className="border-2 border-red-400 rounded-lg p-3 bg-red-50">
                          <div className="text-center mb-2">
                            <span className="bg-red-500 text-white text-xs font-bold px-2 py-1 rounded">SITUACIÓN 1</span>
                          </div>
                          
                          <div className="bg-white rounded-lg p-2 border border-red-300 mb-2">
                            <p className="text-xs text-gray-700 mb-1"><strong>Situación:</strong></p>
                            <p className="text-xs text-gray-800">María tenía 3/4 de pizza, comió 1/4 de pizza, dice: "Me queda 1/4 de pizza"</p>
                          </div>
                          
                          <div className="bg-white rounded-lg p-2 border border-red-300">
                            <p className="text-xs text-red-600">¿Cuál es el error? _____</p>
                            <p className="text-xs text-red-600">Respuesta correcta: ___________</p>
                          </div>
                        </div>
                        
                        <div className="border-2 border-red-300 rounded-lg p-3 bg-red-50">
                          <div className="text-center mb-2">
                            <span className="bg-red-600 text-white text-xs font-bold px-2 py-1 rounded">SITUACIÓN 2</span>
                          </div>
                          
                          <div className="bg-white rounded-lg p-2 border border-red-400 mb-2">
                            <p className="text-xs text-gray-700 mb-1"><strong>Operación:</strong></p>
                            <p className="text-xs text-gray-800 font-mono text-center">2/3 + 1/3 = 3/6</p>
                          </div>
                          
                          <div className="bg-white rounded-lg p-2 border border-red-400">
                            <p className="text-xs text-red-600">¿Cuál es el error? _____</p>
                            <p className="text-xs text-red-600">Respuesta correcta: ___________</p>
                          </div>
                        </div>
                        
                        <div className="border-2 border-red-200 rounded-lg p-3 bg-red-50">
                          <div className="text-center mb-2">
                            <span className="bg-red-700 text-white text-xs font-bold px-2 py-1 rounded">SITUACIÓN 3</span>
                          </div>
                          
                          <div className="bg-white rounded-lg p-2 border border-red-300 mb-2">
                            <p className="text-xs text-gray-700 mb-1"><strong>Conversión:</strong></p>
                            <p className="text-xs text-gray-800 text-center">1/2 = 0.5</p>
                            <p className="text-xs text-gray-800 text-center">Pedro dice: "Esto está mal"</p>
                          </div>
                          
                          <div className="bg-white rounded-lg p-2 border border-red-300">
                            <p className="text-xs text-red-600">¿Cuál es el error? _____</p>
                            <p className="text-xs text-red-600">Respuesta correcta: ___________</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    {/* Hoja de respuestas */}
                    <div className="bg-green-50 rounded-lg p-3 border border-green-200">
                      <h4 className="font-bold text-green-900 text-xs mb-1">📝 SOLUCIONARIO</h4>
                      <div className="text-green-800 text-xs space-y-1">
                        <p><strong>Situación 1:</strong> María dice 1/4 pero: 3/4 - 1/4 = 2/4 = 1/2</p>
                        <p><strong>Situación 2:</strong> Operación muestra 3/6 pero: 2/3 + 1/3 = 3/3 = 1</p>
                        <p><strong>Situación 3:</strong> Pedro está equivocado. 1/2 = 0.5 es correcto</p>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* Badge inferior */}
                <div className="absolute -bottom-4 -left-4 bg-green-600 text-white px-4 py-2 rounded-full text-sm font-bold shadow-xl">
                  📄 Hoja entregable
                </div>
              </div>
              
              {/* Aclaración del ejemplo */}
              <p className="text-xs text-gray-400 text-center mt-4 italic">
                Ejemplo de actividad generada con <span className="text-primary-600 font-medium">Tareia</span>
              </p>
            </div>
          </div>
          
          {/* Mensajes clave */}
          <div className="mt-12 space-y-6">
            <div className="text-center max-w-3xl mx-auto">
              <p className="text-base sm:text-lg text-gray-700 mb-2">
                <span className="font-bold text-primary-600">Tareia adapta cada actividad según tu clase y contexto</span>
              </p>
              <p className="text-sm sm:text-base text-gray-600 mb-4">
                Cada actividad se genera de forma única según lo que necesites
              </p>
              <p className="text-sm sm:text-base text-gray-600">
                Y muchas más actividades adaptadas a tu clase
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InputSimulation;